<template>
  <profile-subsection
    action-text="Change Password"
    :editing="activeSection === 'Password'"
    :disabled="activeSection && activeSection !== 'Password'"
    :disabled-save="!canSubmit"
    :active-btn-type="pwBtnLabelType"
    @inactive-action="$emit('set-active')"
    @active-action="updatePassword"
    @cancel-action="$emit('clear-active')"
  >
    <template v-slot:inactive>
      <p>Password: ********</p>
    </template>
    <template v-slot:active>
      <label
        class="hidden"
        for="new-password"
      >
        New Password:
      </label>
      <input
        id="new-password"
        v-model="password"
        class="icon-input"
        :disabled="submitting"
        :type="visiblePassword === 'password' ? 'text' : 'password'"
        name="new-password"
        placeholder="New Password"
        @input="validatePassword"
        @change="validatePassword"
      >
      <button
        class="password-toggle"
        @click="toggleVisiblePassword('password')"
      >
        <icon name="eye" />
      </button>
      <label
        class="hidden"
        for="confirm-password"
      >
        Confirm Password:
      </label>
      <input
        id="confirm-password"
        v-model="passwordConfirmation"
        class="icon-input"
        :disabled="submitting"
        :type="visiblePassword === 'confirmation' ? 'text' : 'password'"
        name="confirm-password"
        placeholder="Confirm Password"
        @input="validatePassword"
        @change="validatePassword"
      >
      <button
        class="password-toggle"
        @click="toggleVisiblePassword('confirmation')"
      >
        <icon name="eye" />
      </button>
      <p
        v-if="validationFailed && validationMessage"
        class="validation"
      >
        {{ validationMessage }}
      </p>
    </template>
  </profile-subsection>
</template>

<script>
import ProfileSubsection from '@components/profile/subsection';
import Icon from '@components/singletons/icon';

export default {
  components: { ProfileSubsection, Icon },
  props: {
    activeSection: {
      type: String,
    },
    submitting: {
      type: Boolean,
    },
  },
  data() {
    return {
      password: '',
      passwordConfirmation: '',
      pwBtnLabelType: 'text',
      validationFailed: false,
      validationMessage: null,
      visiblePassword: null,
    };
  },
  computed: {
    canSubmit() {
      return this.passwordsEntered && !this.validationFailed;
    },
    passwordsEntered() {
      return this.password.length > 1 && this.passwordConfirmation.length > 1;
    },
  },
  mounted() {
    this.$watch('activeSection', (curr, prev) => {
      if (prev === 'Password' && curr !== 'Password') {
        this.password = '';
        this.passwordConfirmation = '';
        this.validationFailed = false;
        this.validationMessage = null;
      }
    });
  },
  methods: {
    toggleVisiblePassword(inputName) {
      if (inputName === this.visiblePassword) {
        this.visiblePassword = null;
      } else {
        this.visiblePassword = inputName;
      }
    },
    updatePassword() {
      this.$emit('set-submitting', true);
      const params = {
        user: {
          password: this.password,
          passwordConfirmation: this.passwordConfirmation,
        },
      };

      this.$store.dispatch('session/updateUser', params).then(response => {
        // The behvaior here is that we want to disabled the button while submitting
        // But after a successful submission, transition the text to a checkmark icon
        // and automatically close the password section after 3 seconds.
        this.$emit('set-submitting', false);
        this.pwBtnLabelType = 'icon';
        const context = this;
        setTimeout(() => {
          context.$emit('clear-active');
          context.visiblePassword = null;
          context.pwBtnLabelType = 'text';
        }, 3000);
      }).catch(e => {
        this.$notify({
          group: 'notifications',
          text: 'Password Update Failed',
          type: 'error',
        });
      });
    },
    validatePassword() {
      if (this.passwordsEntered) {
        if (this.password !== this.passwordConfirmation) {
          this.validationFailed = true;
          this.validationMessage = 'Passwords must match';
        } else {
          this.validationFailed = false;
          this.validationMessage = null;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.password-toggle {
  float: right;
  padding: rem-calc(14) rem-calc(7);
  margin-top: rem-calc(-51);

  img {
    margin: 0 auto;
    width: rem-calc(16);
  }
}

.validation {
  color: #dc3416;
  margin: 0;
  font-size: rem-calc(12);
}
</style>
